
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.8.1
 * Query Engine version: 78caf6feeaed953168c64e15a249c3e9a033ebe2
 */
Prisma.prismaVersion = {
  client: "5.8.1",
  engine: "78caf6feeaed953168c64e15a249c3e9a033ebe2"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ClientScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  stripePriceId: 'stripePriceId',
  stripeCustomerId: 'stripeCustomerId',
  stripeSubscriptionId: 'stripeSubscriptionId',
  companyName: 'companyName',
  liveTransfer: 'liveTransfer',
  moderationEnabled: 'moderationEnabled',
  sessionsQuota: 'sessionsQuota',
  sessionsCount: 'sessionsCount',
  disabledAt: 'disabledAt',
  emailNotificationStatus: 'emailNotificationStatus'
};

exports.Prisma.ClientLedgerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  numberOfSessions: 'numberOfSessions',
  metadata: 'metadata',
  clientId: 'clientId',
  createdByAdminId: 'createdByAdminId'
};

exports.Prisma.ClientApiKeyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  disabledAt: 'disabledAt',
  clientId: 'clientId'
};

exports.Prisma.ParsedApplicationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  phone: 'phone',
  plaintextPhone: 'plaintextPhone',
  firstName: 'firstName',
  lastName: 'lastName',
  channel: 'channel',
  metadata: 'metadata',
  resumeMimeType: 'resumeMimeType',
  resumeFileName: 'resumeFileName',
  resumeBase64: 'resumeBase64',
  linkFromEmail: 'linkFromEmail',
  parsedApplicationNotContactedReason: 'parsedApplicationNotContactedReason',
  sourceRemoteId: 'sourceRemoteId',
  sourceAppliedAt: 'sourceAppliedAt',
  trackingCode: 'trackingCode',
  smsVisitedInterviewNowPageAt: 'smsVisitedInterviewNowPageAt',
  emailVisitedInterviewNowPageAt: 'emailVisitedInterviewNowPageAt',
  undefinedVisitedInterviewNowPageAt: 'undefinedVisitedInterviewNowPageAt',
  smsStatus: 'smsStatus',
  emailStatus: 'emailStatus',
  jobOfferId: 'jobOfferId'
};

exports.Prisma.ApplicantScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  phone: 'phone',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  zipCode: 'zipCode',
  notifiedAt: 'notifiedAt',
  notifiedCount: 'notifiedCount',
  remoteId: 'remoteId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  firebaseUid: 'firebaseUid',
  role: 'role',
  clientUserPermission: 'clientUserPermission',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  onboardingCompleted: 'onboardingCompleted',
  termsAcceptedAt: 'termsAcceptedAt',
  pushNotificationsEnabled: 'pushNotificationsEnabled',
  approvedAt: 'approvedAt',
  disabledAt: 'disabledAt',
  selectedAt: 'selectedAt',
  photoOriginal: 'photoOriginal',
  photoHigh: 'photoHigh',
  photoLow: 'photoLow',
  residence: 'residence',
  channel: 'channel',
  stripeCustomerId: 'stripeCustomerId',
  zipCode: 'zipCode',
  presence: 'presence',
  firebaseMessagingTokens: 'firebaseMessagingTokens',
  clientId: 'clientId',
  invitationKey: 'invitationKey'
};

exports.Prisma.OfflineVetterNotificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastNotifiedAt: 'lastNotifiedAt',
  startTime: 'startTime',
  endTime: 'endTime',
  userId: 'userId',
  notificationDay: 'notificationDay'
};

exports.Prisma.StripeUserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  stripeAccountId: 'stripeAccountId',
  stripeAccountConnected: 'stripeAccountConnected',
  credit: 'credit'
};

exports.Prisma.JobGroupUserAccessScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  jobGroupId: 'jobGroupId',
  userId: 'userId'
};

exports.Prisma.JobGroupScriptAccessScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  jobGroupId: 'jobGroupId',
  scriptId: 'scriptId'
};

exports.Prisma.JobGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  path: 'path',
  billingId: 'billingId',
  clientId: 'clientId',
  jobOfferId: 'jobOfferId',
  currentCredit: 'currentCredit'
};

exports.Prisma.JobOfferScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  clientNotifiedAt: 'clientNotifiedAt',
  remoteId: 'remoteId',
  title: 'title',
  description: 'description',
  companyName: 'companyName',
  salary: 'salary',
  successClosingLines: 'successClosingLines',
  additionalDescription: 'additionalDescription',
  extendedAIContext: 'extendedAIContext',
  extendedAISummaryContext: 'extendedAISummaryContext',
  maximumRecommendedApplicants: 'maximumRecommendedApplicants',
  automatedSMSTextRecommended: 'automatedSMSTextRecommended',
  automatedSMSTextNotRecommended: 'automatedSMSTextNotRecommended',
  instruction: 'instruction',
  disabledAt: 'disabledAt',
  muted: 'muted',
  clientId: 'clientId',
  emailRecipients: 'emailRecipients',
  supportEmails: 'supportEmails',
  contactQuotaEmails: 'contactQuotaEmails',
  clientOfClient: 'clientOfClient',
  locations: 'locations',
  scriptId: 'scriptId'
};

exports.Prisma.ConversationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastMessageAt: 'lastMessageAt',
  lastMessage: 'lastMessage',
  disabledAt: 'disabledAt',
  toNumber: 'toNumber',
  fromNumber: 'fromNumber',
  marked: 'marked',
  aiReplied: 'aiReplied',
  firstName: 'firstName',
  lastName: 'lastName',
  zendeskTicketId: 'zendeskTicketId',
  lastSessionId: 'lastSessionId',
  parsedApplicationId: 'parsedApplicationId'
};

exports.Prisma.MessageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  text: 'text',
  type: 'type',
  messageSid: 'messageSid',
  kind: 'kind',
  status: 'status',
  metadata: 'metadata',
  conversationId: 'conversationId'
};

exports.Prisma.ScriptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  archivedAt: 'archivedAt',
  recentVersion: 'recentVersion',
  name: 'name',
  isTemplate: 'isTemplate',
  introduction: 'introduction',
  clientId: 'clientId'
};

exports.Prisma.ScriptQuestionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  scriptVersion: 'scriptVersion',
  position: 'position',
  title: 'title',
  description: 'description',
  guide: 'guide',
  isKnockout: 'isKnockout',
  isDealBreaker: 'isDealBreaker',
  isFreeText: 'isFreeText',
  metadata: 'metadata',
  scriptId: 'scriptId'
};

exports.Prisma.ScriptAnswerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  answer: 'answer',
  isCorrectAnswer: 'isCorrectAnswer',
  aiAnswer: 'aiAnswer',
  sessionId: 'sessionId',
  scriptQuestionId: 'scriptQuestionId'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  clientNotifiedAt: 'clientNotifiedAt',
  status: 'status',
  moderationStatus: 'moderationStatus',
  creditEarned: 'creditEarned',
  channel: 'channel',
  creditReason: 'creditReason',
  applicantFeedback: 'applicantFeedback',
  activeDuration: 'activeDuration',
  timeline: 'timeline',
  callSid: 'callSid',
  recordingSid: 'recordingSid',
  recordingUrl: 'recordingUrl',
  notes: 'notes',
  recommended: 'recommended',
  canceled: 'canceled',
  location: 'location',
  source: 'source',
  reportedIssueType: 'reportedIssueType',
  reportedIssueDetail: 'reportedIssueDetail',
  reasonForRecommendation: 'reasonForRecommendation',
  scriptVersion: 'scriptVersion',
  scriptId: 'scriptId',
  isLastForApplicant: 'isLastForApplicant',
  jobOfferId: 'jobOfferId',
  vetterId: 'vetterId',
  applicantId: 'applicantId',
  applicationId: 'applicationId'
};

exports.Prisma.SessionTranscriptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  finishedAt: 'finishedAt',
  sessionId: 'sessionId',
  transcriptionStatus: 'transcriptionStatus',
  summaryStatus: 'summaryStatus',
  result: 'result',
  summary: 'summary',
  summaryResult: 'summaryResult'
};

exports.Prisma.ATSIntegrationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  isJobsAutomationPhaseEnabled: 'isJobsAutomationPhaseEnabled',
  isNewApplicationProcessingPhaseEnabled: 'isNewApplicationProcessingPhaseEnabled',
  isVetteResultsSubmissionPhaseEnabled: 'isVetteResultsSubmissionPhaseEnabled',
  clientId: 'clientId',
  config: 'config',
  isMisconfigurationReported: 'isMisconfigurationReported'
};

exports.Prisma.ApplicationActivityHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  actor: 'actor',
  action: 'action',
  metadata: 'metadata',
  sessionId: 'sessionId',
  applicationId: 'applicationId'
};

exports.Prisma.GlobalActivityHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  actor: 'actor',
  event: 'event',
  metadata: 'metadata'
};

exports.Prisma.ConversationGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  description: 'description',
  sql: 'sql',
  invocationsCount: 'invocationsCount',
  lastInvokedAt: 'lastInvokedAt'
};

exports.Prisma.DayforceBotOpsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  startedAt: 'startedAt',
  finishedAt: 'finishedAt',
  success: 'success',
  newStatus: 'newStatus',
  payload: 'payload',
  error: 'error'
};

exports.Prisma.ModerationTriggerWordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  clientId: 'clientId',
  word: 'word'
};

exports.Prisma.VetterClientPriorityScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  priority: 'priority',
  isBanned: 'isBanned',
  userId: 'userId',
  clientId: 'clientId',
  jobOfferId: 'jobOfferId'
};

exports.Prisma.GrowthBookExperimentVariationAssignmentScalarFieldEnum = {
  userId: 'userId',
  createdAt: 'createdAt',
  experimentId: 'experimentId',
  variationId: 'variationId'
};

exports.Prisma.UserAttributeScalarFieldEnum = {
  id: 'id',
  name: 'name',
  strict: 'strict',
  options: 'options'
};

exports.Prisma.UserAttributeValueScalarFieldEnum = {
  id: 'id',
  values: 'values',
  userId: 'userId',
  attributeId: 'attributeId'
};

exports.Prisma.SessionAttributeValueScalarFieldEnum = {
  id: 'id',
  values: 'values',
  sessionId: 'sessionId',
  attributeId: 'attributeId'
};

exports.Prisma.ClientApplicantBlacklistScalarFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  applicantPhone: 'applicantPhone',
  reason: 'reason'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.ClientOrderByRelevanceFieldEnum = {
  id: 'id',
  stripePriceId: 'stripePriceId',
  stripeCustomerId: 'stripeCustomerId',
  stripeSubscriptionId: 'stripeSubscriptionId',
  companyName: 'companyName'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.ClientLedgerOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  clientId: 'clientId',
  createdByAdminId: 'createdByAdminId'
};

exports.Prisma.ClientApiKeyOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key',
  clientId: 'clientId'
};

exports.Prisma.ParsedApplicationOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  phone: 'phone',
  plaintextPhone: 'plaintextPhone',
  firstName: 'firstName',
  lastName: 'lastName',
  channel: 'channel',
  resumeMimeType: 'resumeMimeType',
  resumeFileName: 'resumeFileName',
  resumeBase64: 'resumeBase64',
  linkFromEmail: 'linkFromEmail',
  parsedApplicationNotContactedReason: 'parsedApplicationNotContactedReason',
  sourceRemoteId: 'sourceRemoteId',
  trackingCode: 'trackingCode',
  jobOfferId: 'jobOfferId'
};

exports.Prisma.ApplicantOrderByRelevanceFieldEnum = {
  id: 'id',
  phone: 'phone',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  zipCode: 'zipCode',
  remoteId: 'remoteId'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  firebaseUid: 'firebaseUid',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  photoOriginal: 'photoOriginal',
  photoHigh: 'photoHigh',
  photoLow: 'photoLow',
  residence: 'residence',
  channel: 'channel',
  stripeCustomerId: 'stripeCustomerId',
  zipCode: 'zipCode',
  firebaseMessagingTokens: 'firebaseMessagingTokens',
  clientId: 'clientId',
  invitationKey: 'invitationKey'
};

exports.Prisma.OfflineVetterNotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId'
};

exports.Prisma.StripeUserOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  stripeAccountId: 'stripeAccountId'
};

exports.Prisma.JobGroupUserAccessOrderByRelevanceFieldEnum = {
  id: 'id',
  jobGroupId: 'jobGroupId',
  userId: 'userId'
};

exports.Prisma.JobGroupScriptAccessOrderByRelevanceFieldEnum = {
  id: 'id',
  jobGroupId: 'jobGroupId',
  scriptId: 'scriptId'
};

exports.Prisma.JobGroupOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  path: 'path',
  billingId: 'billingId',
  clientId: 'clientId',
  jobOfferId: 'jobOfferId'
};

exports.Prisma.JobOfferOrderByRelevanceFieldEnum = {
  id: 'id',
  remoteId: 'remoteId',
  title: 'title',
  description: 'description',
  companyName: 'companyName',
  salary: 'salary',
  successClosingLines: 'successClosingLines',
  additionalDescription: 'additionalDescription',
  extendedAIContext: 'extendedAIContext',
  extendedAISummaryContext: 'extendedAISummaryContext',
  automatedSMSTextRecommended: 'automatedSMSTextRecommended',
  automatedSMSTextNotRecommended: 'automatedSMSTextNotRecommended',
  instruction: 'instruction',
  clientId: 'clientId',
  emailRecipients: 'emailRecipients',
  supportEmails: 'supportEmails',
  contactQuotaEmails: 'contactQuotaEmails',
  clientOfClient: 'clientOfClient',
  locations: 'locations',
  scriptId: 'scriptId'
};

exports.Prisma.ConversationOrderByRelevanceFieldEnum = {
  id: 'id',
  lastMessage: 'lastMessage',
  toNumber: 'toNumber',
  fromNumber: 'fromNumber',
  firstName: 'firstName',
  lastName: 'lastName',
  lastSessionId: 'lastSessionId',
  parsedApplicationId: 'parsedApplicationId'
};

exports.Prisma.MessageOrderByRelevanceFieldEnum = {
  id: 'id',
  text: 'text',
  messageSid: 'messageSid',
  conversationId: 'conversationId'
};

exports.Prisma.ScriptOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  introduction: 'introduction',
  clientId: 'clientId'
};

exports.Prisma.ScriptQuestionOrderByRelevanceFieldEnum = {
  title: 'title',
  description: 'description',
  guide: 'guide',
  scriptId: 'scriptId'
};

exports.Prisma.ScriptAnswerOrderByRelevanceFieldEnum = {
  id: 'id',
  answer: 'answer',
  aiAnswer: 'aiAnswer',
  sessionId: 'sessionId'
};

exports.Prisma.SessionOrderByRelevanceFieldEnum = {
  id: 'id',
  channel: 'channel',
  applicantFeedback: 'applicantFeedback',
  callSid: 'callSid',
  recordingSid: 'recordingSid',
  recordingUrl: 'recordingUrl',
  notes: 'notes',
  location: 'location',
  reportedIssueDetail: 'reportedIssueDetail',
  reasonForRecommendation: 'reasonForRecommendation',
  scriptId: 'scriptId',
  jobOfferId: 'jobOfferId',
  vetterId: 'vetterId',
  applicantId: 'applicantId',
  applicationId: 'applicationId'
};

exports.Prisma.SessionTranscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  summary: 'summary'
};

exports.Prisma.ATSIntegrationOrderByRelevanceFieldEnum = {
  id: 'id',
  clientId: 'clientId'
};

exports.Prisma.ApplicationActivityHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  action: 'action',
  sessionId: 'sessionId',
  applicationId: 'applicationId'
};

exports.Prisma.GlobalActivityHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  actor: 'actor',
  event: 'event'
};

exports.Prisma.ConversationGroupOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  sql: 'sql'
};

exports.Prisma.DayforceBotOpsOrderByRelevanceFieldEnum = {
  id: 'id',
  newStatus: 'newStatus',
  error: 'error'
};

exports.Prisma.ModerationTriggerWordOrderByRelevanceFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  word: 'word'
};

exports.Prisma.VetterClientPriorityOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  clientId: 'clientId',
  jobOfferId: 'jobOfferId'
};

exports.Prisma.GrowthBookExperimentVariationAssignmentOrderByRelevanceFieldEnum = {
  userId: 'userId',
  experimentId: 'experimentId',
  variationId: 'variationId'
};

exports.Prisma.UserAttributeOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  options: 'options'
};

exports.Prisma.UserAttributeValueOrderByRelevanceFieldEnum = {
  id: 'id',
  values: 'values',
  userId: 'userId',
  attributeId: 'attributeId'
};

exports.Prisma.SessionAttributeValueOrderByRelevanceFieldEnum = {
  id: 'id',
  values: 'values',
  sessionId: 'sessionId',
  attributeId: 'attributeId'
};

exports.Prisma.ClientApplicantBlacklistOrderByRelevanceFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  applicantPhone: 'applicantPhone',
  reason: 'reason'
};
exports.emailNotificationStatuses = exports.$Enums.emailNotificationStatuses = {
  PASSED: 'PASSED',
  PASSED_AND_FAILED: 'PASSED_AND_FAILED'
};

exports.ParsedApplicationStatus = exports.$Enums.ParsedApplicationStatus = {
  PROCESSED: 'PROCESSED',
  CONTACTED: 'CONTACTED',
  APPLICANT_REPLIED_POSITIVE: 'APPLICANT_REPLIED_POSITIVE',
  APPLICANT_REPLIED_NEGATIVE: 'APPLICANT_REPLIED_NEGATIVE',
  APPLICANT_REPLIED_UNKNOWN: 'APPLICANT_REPLIED_UNKNOWN'
};

exports.UserRole = exports.$Enums.UserRole = {
  ADMIN: 'ADMIN',
  CLIENT: 'CLIENT',
  VETTER: 'VETTER'
};

exports.ClientUserPermission = exports.$Enums.ClientUserPermission = {
  MANAGE: 'MANAGE',
  INTERVIEW: 'INTERVIEW'
};

exports.UserPresence = exports.$Enums.UserPresence = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  BUSY: 'BUSY'
};

exports.OfflineVettersNotificationDay = exports.$Enums.OfflineVettersNotificationDay = {
  SUNDAY: 'SUNDAY',
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY'
};

exports.MessageType = exports.$Enums.MessageType = {
  RECIEVED: 'RECIEVED',
  SENT: 'SENT'
};

exports.MessageKind = exports.$Enums.MessageKind = {
  SYSTEM_PARSED_APPLICATION_WOULD_YOU_LIKE_TO_INTERVIEW: 'SYSTEM_PARSED_APPLICATION_WOULD_YOU_LIKE_TO_INTERVIEW',
  SYSTEM_PARSED_APPLICATION_INTERVIEW_INSTRUCTIONS: 'SYSTEM_PARSED_APPLICATION_INTERVIEW_INSTRUCTIONS',
  SYSTEM_PARSED_APPLICATION_REENGAGE_SILENT_APPLICANT: 'SYSTEM_PARSED_APPLICATION_REENGAGE_SILENT_APPLICANT',
  SYSTEM_CSV_UPLOAD_APPLICANT_INTERVIEW_INSTRUCTIONS: 'SYSTEM_CSV_UPLOAD_APPLICANT_INTERVIEW_INSTRUCTIONS',
  SYSTEM_SESSION_APPLICANT_DID_NOT_PICKUP: 'SYSTEM_SESSION_APPLICANT_DID_NOT_PICKUP',
  SYSTEM_SESSION_GLOBAL_TIMEOUT: 'SYSTEM_SESSION_GLOBAL_TIMEOUT',
  SYSTEM_SESSION_ASKING_FOR_APPLICANTS_FEEDBACK: 'SYSTEM_SESSION_ASKING_FOR_APPLICANTS_FEEDBACK',
  ADMIN_SENT: 'ADMIN_SENT',
  APPLICANT_OPT_OUT: 'APPLICANT_OPT_OUT',
  APPLICANT_OPT_IN: 'APPLICANT_OPT_IN',
  APPLICANT_OPT_HELP: 'APPLICANT_OPT_HELP',
  AI_AUTO_REPLY: 'AI_AUTO_REPLY'
};

exports.MessageStatus = exports.$Enums.MessageStatus = {
  PENDING: 'PENDING',
  DELIVERED: 'DELIVERED',
  FAILED: 'FAILED',
  QUEUED: 'QUEUED',
  UNDELIVERED: 'UNDELIVERED'
};

exports.SessionStatus = exports.$Enums.SessionStatus = {
  LOOKING_FOR_VETTER: 'LOOKING_FOR_VETTER',
  LOOKING_FOR_VETTER_TIMED_OUT: 'LOOKING_FOR_VETTER_TIMED_OUT',
  WAITING_FOR_VETTER_TO_ACCEPT_SESSION_REQUEST: 'WAITING_FOR_VETTER_TO_ACCEPT_SESSION_REQUEST',
  WAITING_FOR_VETTER_TO_PICKUP_CALL: 'WAITING_FOR_VETTER_TO_PICKUP_CALL',
  WAITING_FOR_VETTER_TO_PRESS_DIGIT: 'WAITING_FOR_VETTER_TO_PRESS_DIGIT',
  WAITING_FOR_APPLICANT_TO_PICKUP_CALL: 'WAITING_FOR_APPLICANT_TO_PICKUP_CALL',
  VETTER_DID_NOT_PICKUP_CALL: 'VETTER_DID_NOT_PICKUP_CALL',
  VETTER_REJECTED_SESSION_REQUEST: 'VETTER_REJECTED_SESSION_REQUEST',
  VETTER_REQUEST_TIMED_OUT: 'VETTER_REQUEST_TIMED_OUT',
  WAITING_FOR_VETTER_TO_CONFIRM_APPLICANT_PICKED_UP: 'WAITING_FOR_VETTER_TO_CONFIRM_APPLICANT_PICKED_UP',
  SESSION_IN_PROGRESS: 'SESSION_IN_PROGRESS',
  APPLICANT_DROPPED_FROM_CALL: 'APPLICANT_DROPPED_FROM_CALL',
  VETTER_DROPPED_FROM_CALL: 'VETTER_DROPPED_FROM_CALL',
  WAITING_FOR_VETTER_TO_PROVIDE_FEEDBACK: 'WAITING_FOR_VETTER_TO_PROVIDE_FEEDBACK',
  APPLICANT_WAS_NOT_REACHABLE: 'APPLICANT_WAS_NOT_REACHABLE',
  APPLICANT_DID_NOT_PICKUP_CALL: 'APPLICANT_DID_NOT_PICKUP_CALL',
  VETTER_CLAIMS_APPLICANT_DID_NOT_PICKUP_CALL: 'VETTER_CLAIMS_APPLICANT_DID_NOT_PICKUP_CALL',
  WAITING_FOR_VETTER_TO_PROVIDE_FEEDBACK_TIMED_OUT: 'WAITING_FOR_VETTER_TO_PROVIDE_FEEDBACK_TIMED_OUT',
  WAITING_FOR_VETTER_TO_CONFIRM_APPLICANT_PICKED_UP_TIMED_OUT: 'WAITING_FOR_VETTER_TO_CONFIRM_APPLICANT_PICKED_UP_TIMED_OUT',
  CALL_DROPPED_TIMED_OUT: 'CALL_DROPPED_TIMED_OUT',
  SESSION_GLOBAL_TIMED_OUT: 'SESSION_GLOBAL_TIMED_OUT',
  SESSION_TERMINATED_BY_ADMIN: 'SESSION_TERMINATED_BY_ADMIN',
  SESSION_FINISHED_WITH_AN_ISSUE: 'SESSION_FINISHED_WITH_AN_ISSUE',
  SESSION_FINISHED_SUCCESSFULLY: 'SESSION_FINISHED_SUCCESSFULLY',
  APPLICANT_DID_NOT_PASS_KNOCKOUT: 'APPLICANT_DID_NOT_PASS_KNOCKOUT'
};

exports.ModerationStatus = exports.$Enums.ModerationStatus = {
  DISABLED: 'DISABLED',
  WAITING: 'WAITING',
  IN_PROGRESS: 'IN_PROGRESS',
  FLAGGED: 'FLAGGED',
  VERIFIED: 'VERIFIED',
  SKIPPED: 'SKIPPED'
};

exports.CreditReason = exports.$Enums.CreditReason = {
  FREE_TRIAL: 'FREE_TRIAL',
  VETTER_ERROR: 'VETTER_ERROR',
  OPERATIONAL_ISSUE: 'OPERATIONAL_ISSUE',
  PREPAID_INVOICE: 'PREPAID_INVOICE'
};

exports.ApplicationLinkSource = exports.$Enums.ApplicationLinkSource = {
  EMAIL: 'EMAIL',
  SMS: 'SMS'
};

exports.SessionReportedIssueType = exports.$Enums.SessionReportedIssueType = {
  CALL_LANDED_TO_APPLICANT_VOICEMAIL: 'CALL_LANDED_TO_APPLICANT_VOICEMAIL',
  APPLICANT_CANNOT_SPEAK_NOW: 'APPLICANT_CANNOT_SPEAK_NOW',
  VETTER_HANG_UP_UNEXPECTEDLY: 'VETTER_HANG_UP_UNEXPECTEDLY',
  APPLICANT_HANG_UP_UNEXPECTEDLY: 'APPLICANT_HANG_UP_UNEXPECTEDLY',
  COULD_NOT_HEAR_EACH_OTHER: 'COULD_NOT_HEAR_EACH_OTHER',
  NEEDS_TRANSLATOR: 'NEEDS_TRANSLATOR',
  OTHER: 'OTHER'
};

exports.TranscriptionStatus = exports.$Enums.TranscriptionStatus = {
  STARTED: 'STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  FAILED: 'FAILED',
  FINISHED: 'FINISHED'
};

exports.SummaryStatus = exports.$Enums.SummaryStatus = {
  WAITING_TO_START: 'WAITING_TO_START',
  IN_PROGRESS: 'IN_PROGRESS',
  FAILED: 'FAILED',
  FINISHED: 'FINISHED'
};

exports.ATSIntegrationType = exports.$Enums.ATSIntegrationType = {
  DAYFORCE: 'DAYFORCE',
  PARADOX: 'PARADOX',
  ZAPIER: 'ZAPIER',
  UIPATH: 'UIPATH'
};

exports.SessionActor = exports.$Enums.SessionActor = {
  APPLICANT: 'APPLICANT',
  VETTER: 'VETTER',
  SYSTEM: 'SYSTEM'
};

exports.Prisma.ModelName = {
  Client: 'Client',
  ClientLedger: 'ClientLedger',
  ClientApiKey: 'ClientApiKey',
  ParsedApplication: 'ParsedApplication',
  Applicant: 'Applicant',
  User: 'User',
  OfflineVetterNotification: 'OfflineVetterNotification',
  StripeUser: 'StripeUser',
  JobGroupUserAccess: 'JobGroupUserAccess',
  JobGroupScriptAccess: 'JobGroupScriptAccess',
  JobGroup: 'JobGroup',
  JobOffer: 'JobOffer',
  Conversation: 'Conversation',
  Message: 'Message',
  Script: 'Script',
  ScriptQuestion: 'ScriptQuestion',
  ScriptAnswer: 'ScriptAnswer',
  Session: 'Session',
  SessionTranscription: 'SessionTranscription',
  ATSIntegration: 'ATSIntegration',
  ApplicationActivityHistory: 'ApplicationActivityHistory',
  GlobalActivityHistory: 'GlobalActivityHistory',
  ConversationGroup: 'ConversationGroup',
  DayforceBotOps: 'DayforceBotOps',
  ModerationTriggerWord: 'ModerationTriggerWord',
  VetterClientPriority: 'VetterClientPriority',
  GrowthBookExperimentVariationAssignment: 'GrowthBookExperimentVariationAssignment',
  UserAttribute: 'UserAttribute',
  UserAttributeValue: 'UserAttributeValue',
  SessionAttributeValue: 'SessionAttributeValue',
  ClientApplicantBlacklist: 'ClientApplicantBlacklist'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
